// can be used in expressions
export const error = (msg?: string): never => {
  throw new Error(msg);
};

// can be used in expressions
export const bug = (msg?: string): never => {
  throw new Error(`Software bug: ${msg}`);
};
